var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", { staticClass: "side-menu" }, [
      _c(
        "ul",
        { staticClass: "side-menu-list list-unstyled" },
        [
          _vm._l(_vm.items, function(item) {
            return [
              item.children
                ? _c(
                    "li",
                    {
                      key: item.name,
                      class: [
                        "with-sub",
                        item.name === _vm.currentMenu ? "opened" : ""
                      ],
                      on: {
                        click: function($event) {
                          return _vm.changeCurrentMenu(item.name)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "side-menu-list-label",
                            attrs: { href: "javascript:void(0)" }
                          },
                          [
                            item.iconClass
                              ? _c("i", { class: item.iconClass }, [
                                  _vm._v(_vm._s(item.iconName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "list-unstyled" },
                        _vm._l(item.children, function(subItem) {
                          return _c(
                            "li",
                            {
                              key: subItem.name,
                              class: [
                                subItem.name == _vm.currentItem ? "active" : ""
                              ]
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.getRoute(subItem, item) },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeRoute(subItem, item)
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "lbl" }, [
                                    _vm._v(_vm._s(subItem.name))
                                  ]),
                                  _vm._v(" "),
                                  subItem.shortcut
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "add",
                                          on: {
                                            click: function(e) {
                                              return _vm.goShortcut(e, subItem)
                                            }
                                          }
                                        },
                                        [_vm._v("ADD")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _c(
                    "li",
                    {
                      key: item.name,
                      class: [item.name === _vm.currentItem ? "active" : ""],
                      on: {
                        click: function($event) {
                          return _vm.changeCurrentMenu(item.name)
                        }
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "label-right",
                          attrs: { href: _vm.getRoute(item) },
                          on: {
                            click: function($event) {
                              return _vm.changeRoute(item)
                            }
                          }
                        },
                        [
                          item.iconClass
                            ? _c("i", { class: item.iconClass }, [
                                _vm._v(_vm._s(item.iconName))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "lbl" }, [
                            _vm._v(_vm._s(item.name))
                          ])
                        ]
                      )
                    ]
                  )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "siteby" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", [
          _vm._v("Copyright © " + _vm._s(_vm.year) + " 72DPI Ltd"),
          _c("br"),
          _vm._v(" \u2028All Rights Reserved.")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-overlay", on: { click: _vm.hide } })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "http://72.digital", target: "_blank" } }, [
      _c("img", {
        attrs: { src: "/img/logos/seventy-two-stacked.svg", alt: "72DPI" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "d-block" }, [_vm._v("72.digital")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4322800e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4322800e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/SideNavigationComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4322800e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/SideNavigationComponent.vue
// module chunks = 0